import { useState } from "react";
import { cn, copyText } from "utils";
import { Icon, ospThemes } from "@ospweb/sdk-ui";

export const Copy = ({
  text,
  iconSize = 16,
  className,
}: {
  text: string;
  iconSize?: number;
  className?: string;
}) => {
  const [isCopy, setIsCopy] = useState(false);

  return (
    <Icon
      data-openreplay-label={isCopy ? "check" : "ai-copy"}
      onClick={(e: React.MouseEvent<HTMLSpanElement>) => {
        e.stopPropagation();
        e.preventDefault();
        copyText(text || "");
        setIsCopy(true);
        setTimeout(() => {
          setIsCopy(false);
        }, 3000);
      }}
      name={isCopy ? "check" : "ai-copy"}
      color={
        isCopy
          ? ospThemes.colors.content_accent1_primary
          : ospThemes.colors.content_tertiary
      }
      size={iconSize}
      className={cn("cursor-pointer", className)}
    />
  );
};
